export default __webpack_public_path__ + "static/media/signed.6b93ecff.svg";